import axios from "utils/axios";
import { GET_SUPPLIER_TRUSTED_COMPANIES_URL } from "config/services";

export const getSupplierTrustedCompanies = async ({ supplierId, entityId, page, signal }) => {
  // Keep current auth defaults, but do not sign out for this optional section's failures.
  const client = axios.create(axios.defaults);
  const response = await client.get(
    `${GET_SUPPLIER_TRUSTED_COMPANIES_URL}/${encodeURIComponent(String(supplierId))}/trusted-companies`,
    { params: { entityId, page, limit: 10 }, signal, timeout: 15000 },
  );
  const payload = response.data?.payload;
  if (response.data?.error || !Array.isArray(payload?.items) || !payload?.pagination) {
    throw new Error("Unable to load company references.");
  }
  return payload;
};
